import React from 'react';
import Flux from '../../../flux/Flux';

class Logo extends React.Component {
	render() {
		return (
			<span className="video-jumbotron__foreground-icon">
				<img src={"/assets/img/" + (Flux.Browser.isSexole() ? "sexole/sexole_x_visit-x_logo.svg" : "logo2.svg")} alt="VISIT-X" height="34" />
			</span>
		);
	}
}

export default Logo;
